import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-iframe-modal',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './iframe-modal.component.html',
  styleUrl: './iframe-modal.component.css',
})
export class IframeModalComponent {
  public linkRelatorio: SafeResourceUrl;
  public tituloRelatorio: string;

  constructor(
    public dialogRef: MatDialogRef<IframeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { linkRelatorio: string; tituloRelatorio: string },
    private sanitizer: DomSanitizer
  ) {
    this.linkRelatorio = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.linkRelatorio);
    this.tituloRelatorio = this.data.tituloRelatorio;

    const iFrame = document.getElementById('iFrame');
    if (iFrame) {
      iFrame.focus();
    }
  }

  fecharModal(): void {
    this.dialogRef.close();
  }
}
